import React from 'react';
import { useAuth } from '../../hooks';
import { usePreconfiguredFetch } from '../../hooks/useProvidePreconfiguredFetch';
import { NavigationProvider } from './NavigationContext';

type Props = {
    children: React.ReactNode;
};

/**
 * App-specific NavigationProvider that wires auth and preconfigured fetch.
 * Fetches navigation data once when user is authenticated.
 * Please use ProvideNavigation instead of NavigationProvider directly.
 * Please always handle auth before using this component.
 */
export const ProvideNavigation: React.FC<Props> = ({ children }) => {
    const { user } = useAuth();
    const { fetchResource } = usePreconfiguredFetch();

    return (
        <NavigationProvider isReady={!!user} fetchFn={fetchResource}>
            {children}
        </NavigationProvider>
    );
};
